import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0147cb75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "career__heroo" }
const _hoisted_3 = {
  style: {"position":"relative"},
  class: "container"
}
const _hoisted_4 = { class: "hero__content_wrapper" }
const _hoisted_5 = { class: "career__hero__title" }
const _hoisted_6 = { class: "text__accent" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "text__accent" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "hero__subTitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero__right_decor" }, null, -1))
const _hoisted_13 = {
  id: "career",
  class: "job mediabuying-section"
}
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "job__wrapper" }
const _hoisted_16 = { class: "mediabuying-section-title" }
const _hoisted_17 = { class: "mediabuying-section-subtitle" }
const _hoisted_18 = { class: "job__list" }
const _hoisted_19 = { class: "job__text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "job__img_wrapper" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7552 17.2223C17.7552 17.8359 17.2578 18.3334 16.6441 18.3334H2.77745C2.1638 18.3334 1.66634 17.8359 1.66634 17.2223V3.35559C1.66634 2.74194 2.1638 2.24448 2.77745 2.24448C3.3911 2.24448 3.88856 2.74194 3.88856 3.35559V14.5398L16.4362 1.99214C16.8701 1.55823 17.5737 1.55823 18.0076 1.99214C18.4415 2.42606 18.4415 3.12957 18.0076 3.56349L5.45991 16.1112H16.6441C17.2578 16.1112 17.7552 16.6086 17.7552 17.2223Z"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Ticker = _resolveComponent("Ticker")!
  const _component_Advantages = _resolveComponent("Advantages")!
  const _component_Choice = _resolveComponent("Choice")!
  const _component_OurStats = _resolveComponent("OurStats")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_RequestModal = _resolveComponent("RequestModal")!
  const _component_SignUpDialog = _resolveComponent("SignUpDialog")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      onLogin: _ctx.onClickLogin,
      onReg: _ctx.onClickReg
    }, null, 8, ["onLogin", "onReg"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('career.title.we')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('career.title.wait')), 1),
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('career.title.in')), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('career.title.ar')), 1),
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('career.title.team')), 1)
          ]),
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('career.subTitle')), 1),
          _createVNode(_component_Button, {
            target: "_blank",
            href: "https://t.me/masons_hr",
            text: "All job offers"
          })
        ]),
        _hoisted_12
      ])
    ]),
    _createVNode(_component_Ticker, { text: 
        `  join to the team of the best!  join to the team of the best!`
       }),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('mediaBuying.job.title')), 1),
            _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('mediaBuying.job.subtitle')), 1)
          ]),
          _createVNode(_component_Button, {
            outlined: "",
            type: "button",
            href: "https://t.me/masons_hr",
            target: "_blank",
            class: "jobSection__btn isHidden",
            text: this.$t('mediaBuying.btn.join'),
            centered: ""
          }, null, 8, ["text"])
        ]),
        _createElementVNode("ul", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaBuyerInfo, (buyer) => {
            return (_openBlock(), _createElementBlock("li", {
              key: buyer.id,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickRequest && _ctx.onClickRequest(...args))),
              class: "job__block"
            }, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(buyer.label), 1),
              _hoisted_20
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_Advantages, { onRequest: _ctx.onClickRequest }, null, 8, ["onRequest"]),
    _createVNode(_component_Ticker, { text: 
        `  join to the team of the best!  join to the team of the best!`
       }),
    _createVNode(_component_Choice),
    _createVNode(_component_OurStats),
    _createVNode(_component_Footer),
    _createVNode(_component_RequestModal, {
      open: _ctx.isLeaveRequestModalOpen,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isLeaveRequestModalOpen = false))
    }, null, 8, ["open"]),
    _createVNode(_component_SignUpDialog, {
      open: _ctx.showRegDialog,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRegDialog = false))
    }, null, 8, ["open"]),
    _createVNode(_component_LoginDialog, {
      open: _ctx.showLoginDialog,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLoginDialog = false))
    }, null, 8, ["open"])
  ]))
}